/* Copyright (c) 2018-2020 CLOUDPILOTS Software & Consulting GmbH */

const makeTheme = (prefersDarkMode) => ({
  palette: {
    type: 'dark',
    primary: {
      contrastText: '#fff',
      dark: '#1b1b1b',
      light: '#6d6d6d',
      main: '#424242',
    },
    secondary: {
      contrastText: '#000',
      dark: '#5a9216',
      light: '#bef67a',
      main: '#8bc34a',
    },
  },
});

export { makeTheme as default };
